import store from "../../store/index";
import axios from "axios";
import { N8N_URL } from "@/env";
//import { useToast } from 'vue-toastification';

//const toast = useToast();

//const user = store.state.user;

const apiN8n = axios.create({
  baseURL: N8N_URL,
});

apiN8n.interceptors.request.use(
  (config) => {
    const currentToken = localStorage.getItem("token");
    if (currentToken) {
      console.log("token ", currentToken);
      config.headers["auth-header"] = `${currentToken}`;
      if (store.state.CidiCookie) {
        config.headers["cidi-header"] = `${store.state.CidiCookie}`;
      }
    }
    return config;
  },
  (error) => {
    console.log("hubo un error en cambiar el token", error);
    return Promise.reject(error);
  }
);

export default apiN8n;